import React from 'react'
import { I18n } from '@front/volcanion/'
import { isRequired } from '@front/squirtle/utils/validators'

import { Grid, Box, StepLabel, StepContent } from '@mui/material'
import _ from 'lodash'

import FormatUtils from '@front/squirtle/utils/format'
import { TextField, MenuSelectorField, SingleOptionSelectorField } from '@front/squirtle'
import { MenuIcon } from '@front/squirtle/components/MenuSelector/component'

import { SuspensionTitleForm } from '@abra/elements/Suspensions'

const FlagIcon = ({ option }) => <>{FormatUtils.getFlagIcon(option?.value)}</>

const Row1 = ({ verifyClientId }) =>
  <Grid container spacing={1}>
    <Grid size={1.5}>
      <TextField name={'client_id'} label={I18n.t('company.id')} debounceTime={250} afterUserChange={verifyClientId} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'info.nace'} label={I18n.t('company.nace')} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'name'} label={I18n.t('name.label', { count: 1 })} required />
    </Grid>
    <Grid size="grow">
      <TextField name={'contact.gsm'} label={I18n.t('phone.label', { count: 1 })} />
    </Grid>
    <Grid size="grow">
      <TextField name={'contact.email'} label={I18n.t('email.label', { count: 1 })} />
    </Grid>
  </Grid>

const Row2 = ({ languages, isManagingRecord, statusColor, statusChange }) =>
  <Grid container spacing={1}>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('status.label', { count: 1 })}
        name={'status'}
        options={_.compact([
          { label: I18n.t('status.active'), value: 'active' },
          { label: I18n.t('status.deleted'), value: 'deleted', disabled: !isManagingRecord },
          { label: I18n.t('status.suspended'), value: 'suspended', disabled: !isManagingRecord }
        ])}
        valueDecoratorProps={{
          sx: { WebkitTextFillColor: statusColor, fontWeight: 600 }
        }}
        selectFirst
        required
        afterChange={statusChange}
      />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        name={'info.language'}
        label={I18n.t('lang', { count: 1 })}
        options={languages}
        selectFirst
        validate={isRequired}
        required
      >
        <MenuIcon><FlagIcon /></MenuIcon>
      </MenuSelectorField>
    </Grid>
    <Grid size="grow">
      <TextField
        name={'contact.address'}
        label={I18n.t('address.label', { count: 1 })}
        validate={isRequired}
        required
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'exclude_heatmap'}
        label={I18n.t('heatmap.exclude_heatmap')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'bypass_heatmap_cascade'}
        label={I18n.t('heatmap.bypass_heatmap_cascade')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'bonus_heatmap'}
        label={I18n.t('heatmap.bonus_heatmap')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='to_check_billing'
        label={I18n.t('billing.control')}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='priority'
        label={I18n.t('priority.label.order')}
        clearOnEmpty={false}
      />
    </Grid>
  </Grid >

const Row3 = () =>
  <Grid container >
    <Grid size={2}>
      <TextField name={'central_priority_number'} label={I18n.t('phone.central_priority')} />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='booker_voucher_management_enabled'
        label={I18n.t('company.booker_voucher_management_enabled')}
      />
    </Grid>
  </Grid>


const PrimarySection = ({ record_id, ...rest }) => <>
  <StepLabel>
    <SuspensionTitleForm
      label={I18n.t('company.label', { count: 1 })}
      record_id={record_id}
      model_name={"company"}
    />
  </StepLabel>
  <StepContent>
    <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Row1 {...rest} />
      <Row2 {...rest} />
      <Row3 />
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
